import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import clsMerge from "../../../../../util/clsMerge";

const AvailableSessionErrorWrapper: FCWithHTMLAttributes = ({
	children,
	className,
}) => {
	return (
		<div
			className={clsMerge(
				"flex flex-col gap-4 border border-gray-300 bg-gray-100 px-6 py-10 lg:items-center lg:gap-10 lg:text-center",
				className
			)}
		>
			{children}
		</div>
	);
};

export default AvailableSessionErrorWrapper;
